import { openApi } from "@/config/httpClient";
import { adminService } from "./adminService";

interface Report {
  label: string;
  url: string;
}

class ReportService {
  getCommonReports(): Promise<Report[]> {
    adminService.getAllRooms().then
    return Promise.resolve([
      // add server-side reports here
    ])
  }

  getOccupancyByRoomAndDate(roomId: string, dateFrom: string, dateUntil: string, type: "BOOKED"|"CANCELLED") {
    return openApi.getTicketReportByAdmin(roomId, dateFrom, dateUntil, type)
      .then(resp => resp.data)
  }

}


const reportService = new ReportService();

export {
  reportService,
  Report
};

